"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.bind");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.parse-float");

require("core-js/modules/es.parse-int");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.calcFtIn = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _formElements = require("@evidation/form-elements");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var HeightSelect = (0, _styledComponents["default"])(_formElements.SelectInput).withConfig({
  displayName: "fieldHeight__HeightSelect",
  componentId: "qh3ash-0"
})(["display:block;width:50%;max-width:140px;"]);
var ftOptions = [{
  label: "3'",
  value: 3
}, {
  label: "4'",
  value: 4
}, {
  label: "5'",
  value: 5
}, {
  label: "6'",
  value: 6
}, {
  label: "7'",
  value: 7
}];
var inOptions = [{
  label: "0\"",
  value: 0
}, {
  label: "0.5\"",
  value: 0.5
}, {
  label: "1\"",
  value: 1
}, {
  label: "1.5\"",
  value: 1.5
}, {
  label: "2\"",
  value: 2
}, {
  label: "2.5\"",
  value: 2.5
}, {
  label: "3\"",
  value: 3
}, {
  label: "3.5\"",
  value: 3.5
}, {
  label: "4\"",
  value: 4
}, {
  label: "4.5\"",
  value: 4.5
}, {
  label: "5\"",
  value: 5
}, {
  label: "5.5\"",
  value: 5.5
}, {
  label: "6\"",
  value: 6
}, {
  label: "6.5\"",
  value: 6.5
}, {
  label: "7\"",
  value: 7
}, {
  label: "7.5\"",
  value: 7.5
}, {
  label: "8\"",
  value: 8
}, {
  label: "8.5\"",
  value: 8.5
}, {
  label: "9\"",
  value: 9
}, {
  label: "9.5\"",
  value: 9.5
}, {
  label: "10\"",
  value: 10
}, {
  label: "10.5\"",
  value: 10.5
}, {
  label: "11\"",
  value: 11
}, {
  label: "11.5\"",
  value: 11.5
}];

var calcFtIn = function calcFtIn() {
  var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    ft: Math.floor(v / 12),
    inch: v % 12
  };
};

exports.calcFtIn = calcFtIn;

var calcTotalIn = function calcTotalIn(_ref) {
  var _ref$ft = _ref.ft,
      ft = _ref$ft === void 0 ? 0 : _ref$ft,
      _ref$inch = _ref.inch,
      inch = _ref$inch === void 0 ? 0 : _ref$inch;
  return ft * 12 + inch;
};

var HeightSelector = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(HeightSelector, _PureComponent);

  var _super = _createSuper(HeightSelector);

  function HeightSelector(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, HeightSelector);
    _this = _super.call(this, props);

    var _calcFtIn = calcFtIn(props.input.value),
        _calcFtIn$ft = _calcFtIn.ft,
        ft = _calcFtIn$ft === void 0 ? undefined : _calcFtIn$ft,
        _calcFtIn$inch = _calcFtIn.inch,
        inch = _calcFtIn$inch === void 0 ? undefined : _calcFtIn$inch;

    _this.state = {
      ft: ft,
      inch: inch === 0 ? undefined : inch
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(HeightSelector, [{
    key: "onChange",
    value: function onChange(value, id) {
      var _this2 = this;

      var _this$props$input = this.props.input,
          onChange = _this$props$input.onChange,
          onBlur = _this$props$input.onBlur;
      this.setState(function (_ref2) {
        var ft = _ref2.ft,
            inch = _ref2.inch;
        return id === "ft" ? {
          ft: value,
          inch: parseFloat(inch)
        } : {
          ft: parseInt(ft, 10),
          inch: value
        };
      }, function () {
        onBlur();
        onChange(parseFloat(calcTotalIn(_this2.state)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          labelStyle = _this$props.labelStyle,
          _onBlur = _this$props.input.onBlur,
          inputStyle = _this$props.inputStyle,
          label = _this$props.label,
          _this$props$meta = _this$props.meta,
          error = _this$props$meta.error,
          touched = _this$props$meta.touched,
          _this$props$config$re = _this$props.config.required,
          required = _this$props$config$re === void 0 ? false : _this$props$config$re,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled;
      var _this$state = this.state,
          ft = _this$state.ft,
          inch = _this$state.inch;
      return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        required: required,
        labelStyle: labelStyle,
        label: "".concat(label)
      }, /*#__PURE__*/_react["default"].createElement(HeightSelect, {
        className: "height ".concat((0, _utils.constructFieldClassname)(this.props.meta)),
        id: "t-height_ft",
        inputStyle: inputStyle,
        options: ftOptions,
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          return _this3.onChange(parseInt(value, 10), "ft");
        },
        onBlur: function onBlur() {
          _onBlur(parseFloat(calcTotalIn(_this3.state)));
        },
        value: "".concat(ft),
        initialValue: "-Ft-",
        disabled: disabled
      }), /*#__PURE__*/_react["default"].createElement(HeightSelect, {
        className: "height ".concat((0, _utils.constructFieldClassname)(this.props.meta)),
        id: "t-height_inch",
        inputStyle: inputStyle,
        options: inOptions,
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;
          return _this3.onChange(parseFloat(value), "inch");
        },
        value: "".concat(inch),
        onBlur: function onBlur() {
          _onBlur(parseFloat(calcTotalIn(_this3.state)));
        },
        initialValue: "-In-",
        disabled: disabled
      }), touched && error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error));
    }
  }]);
  return HeightSelector;
}(_react.PureComponent);

var _default = HeightSelector;
exports["default"] = _default;